define('specific/popin-rules/models/PopinRulesModel', [

], function() {

    var PopinRulesModel = Backbone.Model.extend({
        defaults: {
            type: "popinrulesview",
            viewId: "",
            loadingInProgress: false,
            isReady: false,
            nbImagesToAdd: 12,
            nbImagesDisplayed: 0,
            nbImagesRequested: 0
        }
    });

    return PopinRulesModel;
});
